import { service } from "../../../redux/api/axios";
import type {
  MfaCohortConfirmResponse,
  MfaEnrollBeginResponse,
  MyCohortStatus,
  MfaEnrollConfirmResponse,
  MfaRequestEmailCodeResponse,
  MfaSession,
} from "../types/mfa.types";

export const verifyChallenge = (challengeToken: string, code: string) =>
  service
    .post<MfaSession>("/mfa/verify", { challengeToken, code })
    .then((r) => r.data);

export const requestEmailCode = (challengeToken: string) =>
  service
    .post<MfaRequestEmailCodeResponse>("/mfa/verify/request-email-code", {
      challengeToken,
    })
    .then((r) => r.data);

export const enrollBegin = () =>
  service.post<MfaEnrollBeginResponse>("/mfa/enroll/begin").then((r) => r.data);

export const enrollConfirm = (provisionalSecret: string, code: string) =>
  service
    .post<MfaEnrollConfirmResponse>("/mfa/enroll/confirm", {
      provisionalSecret,
      code,
    })
    .then((r) => r.data);

// Cohort-forced enrolment. Unlike the self-service pair above these are
// unauthenticated — the user has no session yet, so proof of the password step
// rides on the enrol challenge token issued by /login.
export const cohortEnrollBegin = (challengeToken: string) =>
  service
    .post<MfaEnrollBeginResponse>("/mfa/enroll/begin-cohort", { challengeToken })
    .then((r) => r.data);

export const cohortEnrollConfirm = (
  challengeToken: string,
  provisionalSecret: string,
  code: string
) =>
  service
    .post<MfaCohortConfirmResponse>("/mfa/enroll/confirm-cohort", {
      challengeToken,
      provisionalSecret,
      code,
    })
    .then((r) => r.data);

// The signed-in user's own cohort deadline, or {cohort:null} if they are not
// in one / already enrolled. Powers the in-app pre-deadline banner.
export const getMyCohortStatus = () =>
  service.get<MyCohortStatus>("/mfa/my-cohort").then((r) => r.data);

export const disableMfa = (password: string) =>
  service.post<void>("/mfa/disable", { password }).then((r) => r.data);

export const regenerateRecoveryCodes = () =>
  service
    .post<MfaEnrollConfirmResponse>("/mfa/recovery-codes/regenerate")
    .then((r) => r.data);
